<template>
  <div>
    <!--audio ***********************************************-->
    <!-- <v-dialog v-model="player" width="400px" style="overflow-x: hidden" :key="recordFile">
      <v-card width="400px">
        <v-row justify="center" style="overflow-x: hidden" no-gutters>
          <v-col cols="10" style="text-align: center" class="mt-4">
            <audio controls oncontextmenu="return false;" controlsList="nodownload" cors-anonym="true" autoplay
              :src="recordFile" ref="audioFile"></audio>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="no-letter-space" @click="stopMusic()">بستن E</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">گزارش تماس ها</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n16">
              <v-btn elevation="0" fab @click="backToReport()" color="darkColor" x-small class="mr-n16 mt-4">
                <v-icon color="white">mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table :headers="tableHeader" :items="tableItems" :page.sync="page"
                          :items-per-page="tableItems.length" height="62vh" :search="searchTitle"
                          :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                    @click="playAudioFunction(item.callLogId)" v-on="on">
                                    mdi-play-circle
                                  </v-icon>
                                </template>
                                <span>پخش صوت</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                                    @click="downloadAudioFunction(item.callLogId, item?.from)" v-bind="attrs" v-on="on">
                                    mdi-tray-arrow-down
                                  </v-icon>
                                </template>
                                <span>دانلود</span>
                              </v-tooltip>
                              <v-spacer></v-spacer>
                            </v-row>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import CryptoJS from 'crypto-js';

import AlertComponent from '../../../components/AlertComponent.vue';
import PaginationComponent from '../../../components/PaginationComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
import User115AllCallsHelper from '@/Helpers/QC/UsersDashboard/User115AllCallsHelper.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
import CallMixin from '@/Mixins/Call/CallMixin';
import CallTagMixin from '@/Mixins/Call/CallTagMixin';
export default {
  name: 'User115AllCalls',
  title: 'گزارش تماس ها ',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
  },
  mixins: [
    pagination,
    ShearedMixin,
    ReportMixin,
    User115AllCallsHelper,
    snackBar,
    ShearedHelper,
    CallMixin,
    UserMixin,
    CallTagMixin,
  ],
  created() {
    this.$root.$refs.User115AllCalls = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let route = this.$route.params.id;
      let roteInfo = route.split('$$');
      let rolebytes = CryptoJS.AES.decrypt(roteInfo[0], 'f9rr8Y2D96Klh87N');
      let roleId = '';
      if (rolebytes.sigBytes != 0) {
        roleId = JSON.parse(rolebytes.toString(CryptoJS.enc.Utf8));
      } else {
        roleId = '';
      }
      this.roleId = roleId;

      let userbytes = CryptoJS.AES.decrypt(roteInfo[1], 'f9rr8Y2D96Klh87N');
      let userId = '';
      if (userbytes.sigBytes != 0) {
        userId = JSON.parse(userbytes.toString(CryptoJS.enc.Utf8));
      } else {
        userId = '';
      }
      this.userId = userId;
      this.userFullName = roteInfo[2];
      this.searchFromDate = roteInfo[3];
      this.searchToDate = roteInfo[4];
      this.tempSearchFromDate = Vue.moment(this.searchFromDate).format('HH:mm:ss jDD-jMM-jYYYY');
      this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jDD-jMM-jYYYY');
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
    },
    previous: function () {
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {},
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}
</style>
